import React from 'react';
import { motion } from 'framer-motion';
import { Store, UtensilsCrossed, Car, Briefcase, Building, TrendingUp } from 'lucide-react';
const clientTypes = [{
  icon: Store,
  label: 'Retail'
}, {
  icon: UtensilsCrossed,
  label: 'Restaurantes'
}, {
  icon: Car,
  label: 'Concesionarios'
}, {
  icon: Briefcase,
  label: 'Servicios profesionales'
}, {
  icon: Building,
  label: 'Oficinas'
}, {
  icon: TrendingUp,
  label: 'Otros negocios establecidos'
}];
export function IdealClientsSection() {
  return <section className="bg-lightGray py-16 md:py-24" data-id="element-90">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-92">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-4" data-id="element-93">
            ¿Es esto para ti?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-94">
            Trabajamos con negocios establecidos que procesan más de $30,000 al
            mes
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6" data-id="element-95">
          {clientTypes.map((client, index) => {
          const Icon = client.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-lg shadow-md text-center hover:shadow-xl transition-shadow" data-id="element-96">
                <div className="w-16 h-16 bg-navy bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-97">
                  <Icon className="text-navy" size={28} data-id="element-98" />
                </div>
                <p className="text-sm font-semibold text-navy" data-id="element-99">
                  {client.label}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}